<template>
  <div class="package-info ccs-fields">
    <div class="ccs-field ccs-12">
      <div class="field-name">
        Наименование пакета
      </div>
      <ccs-input class="field-value" type="text"
        v-model="packageInfo.name" :readOnly="!editing"/>
    </div>
    <div class="ccs-field ccs-12">
      <div class="field-name">
         Стоимость пакета
      </div>
      <ccs-input class="field-value" type="text"
        v-model.number="packageInfo.price" :readOnly="!editing"/>
    </div>
    <div class="ccs-field ccs-12">
      <div class="field-name">
        Стоимость дополнительного дня
      </div>
      <ccs-input class="field-value" type="text"
        v-model.number="packageInfo.additional_price" :readOnly="!editing"/>
    </div>
    <div class="ccs-field ccs-12">
      <div class="field-name">
        Дата начала действия пакета
      </div>
      <ccs-input class="field-value" type="date"
        v-model="packageInfo.started_at" :readOnly="!editing"/>
    </div>
    <div class="ccs-field ccs-12">
      <div class="field-name">
        Дата окончания действия пакета
      </div>
      <ccs-input class="field-value" type="date"
        v-model="packageInfo.expired_at" :readOnly="!editing"/>
    </div>
    <div class="ccs-field ccs-12" v-if="editing">
      <div class="field-name">
        Роль назначения (для кого доступен пакет)
      </div>
      <ccs-input v-if="editing" class="ccs-7" type="autocomplete"
        v-model="roleID" @change="onRoleSearch" placeholder="Введите 3 символа для поиска"
        :items="rolesForSelect"/>
      <div v-if="editing" class="ccs-2 roles-button">
        <button class="ccs-button ccs-button--small ccs-12" @click="addRole">
          Добавить
        </button>
      </div>
    </div>
    <div class="ccs-field ccs-12">
      <div class="field-name" v-if="!editing">
        Роль назначения (для кого доступен пакет)
      </div>
      <div class="field-name" v-else></div>
      <div class="ccs-tag ccs-tag--normal" v-for="(item, index) in roles" :key="index"
        @click="removeRole(item)">
        {{ `#${item.name}` }}
      </div>
      <div v-if="!editing && (!roles || roles.length === 0)">
        Не назначены
      </div>
    </div>
    <div class="ccs-layout ccs-layout--no-pad">
      <div v-if="!editing" class="info-button">
        <button v-if="permissionsStatus.isPackageUpdateAllowed"
          class="ccs-button" @click="switchEditing">
          Редактировать
        </button>
      </div>
      <div v-else class="info-button">
        <button class="ccs-button" @click="confirmEditing">
          Сохранить изменения
        </button>
      </div>
      <div v-if="editing">
        <button class="ccs-button ccs-button--light" @click="cancelEditing">
          Отмена
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';

import AutocompleteParent from '@/mixins/AutocompleteParent.js';

import Input from '@/components/forms/Input.vue';

export default {
  name: 'PackageInfo',
  mixins: [AutocompleteParent],
  components: {
    'ccs-input': Input,
  },
  data() {
    return {
      editing: false,
      roleID: undefined,
      rolesForSelect: [],
      packageInfo: {
        id: 0,
        name: '',
        price: '',
        additional_price: '',
        started_at: new Date(),
        expired_at: new Date(),
        created_at: new Date(),
        updated_at: new Date(),
      },
    };
  },
  computed: {
    ...mapState('packages', ['pkg', 'roles']),
    ...mapState('session', ['permissions']),
    ...mapGetters('session', ['permissionsStatus']),
  },
  methods: {
    ...mapActions('packages', ['getPackage', 'updatePackage', 'addRoleToPackage', 'deleteRoleFromPackage']),
    async onRoleSearch(text) {
      [this.rolesForSelect] = await this.getAutocompleteData('/v1/events/roles/list', text);
    },
    async confirmEditing() {
      try {
        await this.updatePackage(this.packageInfo);
        this.$toasted.success('Изменения сохранены');
        this.switchEditing();
      } catch (err) {
        this.$toasted.error(err.message);
        this.cancelEditing();
      }
    },
    async addRole() {
      if (this.roleID) {
        try {
          await this.addRoleToPackage({
            roleID: this.roleID,
            packageID: this.pkg.id
          });
          this.getPackage();
          this.$toasted.success('Роль добавлена');
        } catch (err) {
          this.$toasted.error(err.message);
          return;
        }
        this.roleID = undefined;
      }
    },
    async removeRole(role) {
      try {
        await this.deleteRoleFromPackage({
          roleID: role.id,
          packageID: this.pkg.id
        });
        this.getPackage();
        this.$toasted.success('Роль удалена');
      } catch (err) {
        this.$toasted.error(err.message);
        return;
      }
    },
    switchEditing() {
      this.editing = !this.editing;
    },
    cancelEditing() {
      this.resetPackageInfo();
      this.switchEditing();
    },
    resetPackageInfo() {
      this.packageInfo = {
        id: this.pkg.id,
        name: this.pkg.name,
        price: this.pkg.price,
        additional_price: this.pkg.additional_price,
        started_at: this.pkg.started_at,
        expired_at: this.pkg.expired_at,
      };
    },
  },
  watch: {
    pkg: {
      immediate: true,
      handler(pkg) {
        this.packageInfo = {
          id: pkg.id,
          name: pkg.name,
          price: pkg.price,
          additional_price: pkg.additional_price,
          started_at: pkg.started_at,
          expired_at: pkg.expired_at,
        };
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.package-info {
  min-height: 100%;
  min-width: 100%;
  background: #fff;

  .info-button {
    padding-left: 0;
  }

  .button--add {
    margin-top: 22px;
  }

  .roles-button {
    margin-left: 20px;
  }

}
</style>
